require([
    'SimulatePageState/SimulatePageState',
    'OpenInNewTab/OpenInNewTab',
    'ScrollToTerm/ScrollToTerm',
    'RunOnEveryPage/components/formSpinner',
    'RunOnEveryPage/components/formValidationErrorHandling'
],
    function (simulatePageState, openInNewTab, scrollToTerm, formSpinner, formValidationErrorHandling) {
        $(document).ready(function () {
            simulatePageState.start();
            openInNewTab.start();
            scrollToTerm.start();
            formSpinner.init();
            formValidationErrorHandling.init();
        });
    });

define("RunOnEveryPage/main", function(){});

